import { FilterElementType } from "@utils/DynamicComponentUtils";
import {
  exposureStatusCheck,
  textFormat,
  upDataAtFormat,
} from "@utils/TableItemFormattingUtils";
import { ColDef } from "ag-grid-community";
import {
  CommonFilterDataType,
  CommonFormType,
  CommonPostDateType,
} from "src/types/common";

export interface EventInitialValues extends CommonPostDateType {
  title?: string;
  isExposed?: string;
}

export interface EventFormType extends CommonFormType {
  secondName?: string;
}

export const eventData: CommonFilterDataType<
  EventInitialValues,
  EventFormType,
  ColDef
> = {
  formInitialValues: {
    title: "",
    isExposed: "",
    startDate: "",
    endDate: "",
  },
  forms: [
    {
      type: FilterElementType.INPUT,
      name: "title",
      label: "제목",
    },
    {
      type: FilterElementType.SELECT,
      name: "isExposed",
      label: "노출 상태",
      option: [
        {
          label: "전체",
          value: "",
        },
        {
          label: "노출",
          value: true,
        },
        {
          label: "미노출",
          value: false,
        },
      ],
    },
    {
      type: FilterElementType.DATE_RANGE_PICKER,
      name: "startDate",
      secondName: "endDate",
      label: "게시 기간",
    },
  ],
  tableList: [
    {
      field: "id",
      headerName: "게시물ID",
      maxWidth: 120,
      minWidth: 100,
      flex: 1,
      suppressMovable: true,
      cellRenderer: textFormat,
    },
    {
      field: "postDataAt",
      headerName: "게시 기간",
      minWidth: 200,
      maxWidth: 380,
      flex: 1,
      suppressMovable: true,
      cellRenderer: textFormat,
    },
    {
      field: "isExposed",
      headerName: "노출 상태",
      maxWidth: 120,
      flex: 1,
      cellRenderer: exposureStatusCheck,
      suppressMovable: true,
    },
    {
      field: "title",
      headerName: "제목",
      width: 750,
      flex: 1,
      suppressMovable: true,
      cellRenderer: textFormat,
    },
    {
      field: "updatedAt",
      headerName: "업데이트 일시",
      minWidth: 180,
      maxWidth: 210,
      flex: 1,
      suppressMovable: true,
      cellRenderer: upDataAtFormat,
    },
    {
      field: "manager",
      headerName: "마지막 수정",
      pinned: "right",
      suppressMovable: true,
      maxWidth: 180,
      cellRenderer: textFormat,
    },
  ],
};
